import classNames from "classnames";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import IconCloseSVG from "../../svg/icon-close";
import styles from "./Modal.module.scss";

const BaseModal = ({
  id,
  className,
  dialogClassName,
  bodyClassName,
  isOpen,
  title,
  toggle = () => {},
  closeBtn = true,
  centered = false,
  children,
}) => (
  <Modal id={id} isOpen={isOpen} toggle={toggle} className={className} contentClassName={dialogClassName} centered={centered}>
    <ModalBody className={classNames([styles.body, bodyClassName])}>
      {closeBtn && (
        <span className={styles.close} onClick={toggle}>
          <IconCloseSVG />
        </span>
      )}
      {title && <h4 className={styles.title}>{title}</h4>}

      {children}
    </ModalBody>
  </Modal>
);

export default BaseModal;
